import { CREATEKEYRESULT_SUCCESS, CREATEKEYRESULT_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const createKeyResultReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEKEYRESULT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATEKEYRESULT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createKeyResultReducer;



